import {
  //
  ADD_ALLERGY,
  ADD_ALLERGY_FAILURE,
  ADD_ALLERGY_SUCCESS,
  //
  DELETE_ALLERGY,
  DELETE_ALLERGY_FAILURE,
  DELETE_ALLERGY_SUCCESS,
  //
  EDIT_ALLERGY,
  EDIT_ALLERGY_FAILURE,
  EDIT_ALLERGY_SUCCESS,
  //
  FETCH_ALLERGY,
  FETCH_ALLERGY_FAILURE,
  FETCH_ALLERGY_SUCCESS,
  //
  FETCH_ALLERGY_REGISTER,
  FETCH_ALLERGY_REGISTER_FAILURE,
  FETCH_ALLERGY_REGISTER_SUCCESS,
  //
  REGISTER_DATA_TOUCHED,
  //
  SET_REGISTER_ASSERTION,
  SET_REGISTER_ASSERTION_FAILURE,
  SET_REGISTER_ASSERTION_SUCCESS,
  //
  TOGGLE_ALLERGY_MODAL,
} from "./constants";

// List
export const fetchAllergy = (payload, onSuccess) => ({
  type: FETCH_ALLERGY,
  payload,
  onSuccess,
});
export const fetchAllergySuccess = (payload) => ({
  type: FETCH_ALLERGY_SUCCESS,
  payload,
});
export const fetchAllergyFailure = (payload) => ({
  type: FETCH_ALLERGY_FAILURE,
  payload,
});
// ADD
export const addAllergy = (payload, onAdd, onError) => ({
  type: ADD_ALLERGY,
  payload,
  onAdd,
  onError,
});
export const addAllergySuccess = (payload) => ({
  type: ADD_ALLERGY_SUCCESS,
  payload,
});
export const addAllergyFailure = (payload) => ({
  type: ADD_ALLERGY_FAILURE,
  payload,
});
// EDIT
export const editAllergy = (payload, onEdit, onError) => ({
  type: EDIT_ALLERGY,
  payload,
  onEdit,
  onError,
});
export const editAllergySuccess = (payload) => ({
  type: EDIT_ALLERGY_SUCCESS,
  payload,
});
export const editAllergyFailure = (payload) => ({
  type: EDIT_ALLERGY_FAILURE,
  payload,
});
// DELETE
export const deleteAllergy = (payload, onDelete, onError) => ({
  type: DELETE_ALLERGY,
  payload,
  onDelete,
  onError,
});
export const deleteAllergySuccess = (payload) => ({
  type: DELETE_ALLERGY_SUCCESS,
  payload,
});
export const deleteAllergyFailure = (payload) => ({
  type: DELETE_ALLERGY_FAILURE,
  payload,
});

// Modal
export const toggleAllergyModal = (payload) => ({
  type: TOGGLE_ALLERGY_MODAL,
  payload,
});

// A register changed (any CRUD across allergies / vaccinations / baselines).
// Carries no payload — it only bumps `registerDataVersion` so chip counts that
// read register rows once per resident refetch. See ResidentTopBar deps.
export const registerDataTouched = () => ({
  type: REGISTER_DATA_TOUCHED,
});

// Register (rows + rag + assertions) — payload: { residentId, registerKey }
export const fetchAllergyRegister = (payload, onSuccess) => ({
  type: FETCH_ALLERGY_REGISTER,
  payload,
  onSuccess,
});
export const fetchAllergyRegisterSuccess = (payload) => ({
  type: FETCH_ALLERGY_REGISTER_SUCCESS,
  payload,
});
export const fetchAllergyRegisterFailure = (payload) => ({
  type: FETCH_ALLERGY_REGISTER_FAILURE,
  payload,
});
// Register assertion — payload:
// { residentId, registerKey, assertion, assertionUuid, active }
// (assertionUuid identifies the row to remove when active=false)
export const setRegisterAssertion = (payload, onSuccess, onError) => ({
  type: SET_REGISTER_ASSERTION,
  payload,
  onSuccess,
  onError,
});
export const setRegisterAssertionSuccess = (payload) => ({
  type: SET_REGISTER_ASSERTION_SUCCESS,
  payload,
});
export const setRegisterAssertionFailure = (payload) => ({
  type: SET_REGISTER_ASSERTION_FAILURE,
  payload,
});
